import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punemumbaidailycabservice() {



  const cardData = {


  keyword: "Pune Mumbai Daily Cab Service",

  headingDescription: "Trustline Cab provides reliable Pune Mumbai daily cab services for corporate employees, business professionals, regular travelers, airport transfers, and daily commuters. Our dedicated daily taxi service between Pune and Mumbai offers comfortable, punctual, and cost-effective travel solutions with flexible schedules. Whether you need a daily one-way cab, round-trip service, office pickup and drop, Mumbai airport transfer, or corporate transportation, our experienced chauffeurs ensure a smooth journey via the Mumbai-Pune Expressway. Our fleet includes AC Sedans, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to meet every travel requirement. With professional drivers, well-maintained cars, transparent pricing, doorstep pickup, customized travel plans, and 24/7 customer support, Trustline Travels is your trusted choice for Pune Mumbai daily cab services.",

  topPlaces: [
    {
      title: "Bandra Kurla Complex (BKC)",
      description: "Bandra Kurla Complex is Mumbai's leading business district, home to multinational companies, financial institutions, corporate offices, convention centers, and luxury hotels. It is a preferred destination for daily corporate travelers from Pune."
    },
    {
      title: "Andheri",
      description: "Andheri is one of Mumbai's busiest commercial areas, featuring IT companies, corporate offices, entertainment hubs, hotels, and excellent connectivity to Mumbai Airport. It is a major destination for business commuters."
    },
    {
      title: "Powai",
      description: "Powai is a premium Mumbai locality known for Hiranandani Gardens, technology companies, business parks, luxury hotels, restaurants, and Powai Lake. It is popular among professionals and corporate travelers."
    },
    {
      title: "Lower Parel",
      description: "Lower Parel is a major commercial and business hub of Mumbai, featuring corporate offices, premium malls, luxury hotels, restaurants, and modern workspaces. It attracts daily business travelers."
    },
    {
      title: "Nariman Point",
      description: "Nariman Point is one of Mumbai's oldest and most prestigious business districts, known for corporate offices, financial institutions, sea-facing buildings, and important commercial establishments."
    },
    {
      title: "Hinjewadi IT Park",
      description: "Hinjewadi IT Park is Pune's largest technology hub, home to multinational companies, software firms, startups, and corporate campuses. It is a major pickup and drop location for Mumbai-Pune daily commuters."
    },
    {
      title: "Kharadi",
      description: "Kharadi is Pune's prominent IT and commercial destination featuring EON IT Park, corporate offices, financial companies, and modern business infrastructure. It is a preferred location for professionals."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a world-class integrated township in Pune offering IT parks, corporate offices, residential communities, shopping destinations, and business facilities."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station located between Mumbai and Pune, famous for waterfalls, valleys, viewpoints, and pleasant weather. It is a popular stopover destination on the Mumbai-Pune route."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport provides connectivity to major cities across India and is a common destination for daily travelers requiring reliable airport transfer and corporate cab services."
    }
  ],






"services": [
  {
    "name": "Pune Mumbai Daily Cab Rates",
    "description": "Check Pune Mumbai Daily Cab Rates with transparent pricing, affordable daily travel packages, multiple vehicle options, professional chauffeurs, and comfortable transportation for regular office, business, and personal trips."
  },
  {
    "name": "Pune Mumbai Airport Drop Daily Cab",
    "description": "Book Pune Mumbai Airport Drop Daily Cab for punctual airport transfers with clean AC vehicles, experienced drivers, fixed fares, luggage assistance, and reliable daily travel service."
  },
  {
    "name": "Pune Mumbai Airport Daily One Way Cab",
    "description": "Reserve Pune Mumbai Airport Daily One Way Cab with instant booking, professional chauffeurs, comfortable Sedan, Ertiga, and Innova vehicles for hassle-free airport travel."
  },
  {
    "name": "Pune to Dadar Daily Cab Service",
    "description": "Choose Pune to Dadar Daily Cab Service for regular commuting with affordable fares, flexible timings, experienced drivers, and comfortable AC vehicles."
  },
  {
    "name": "Pune to Mumbai Cheapest Cab Service",
    "description": "Book Pune to Mumbai Cheapest Cab Service with economical pricing, clean vehicles, professional drivers, and reliable daily intercity transportation."
  },
  {
    "name": "Pune to Mumbai Cab Travel Time",
    "description": "Know Pune to Mumbai Cab Travel Time with comfortable highway journeys, experienced chauffeurs, timely pickup, and smooth destination drop service."
  },
  {
    "name": "Pune to Mumbai Daily Cab Contact Number",
    "description": "Contact Pune to Mumbai Daily Cab Service for instant booking assistance, fare details, vehicle availability, and regular travel support."
  },
  {
    "name": "Pune to Mumbai Airport Daily Cab Number",
    "description": "Book Pune to Mumbai Airport Daily Cab with reliable pickup, professional drivers, fixed pricing, and convenient airport transportation."
  },
  {
    "name": "Pune to Mumbai Daily Car Hire",
    "description": "Hire Pune to Mumbai Daily Car with Sedan, Ertiga, Innova Crysta, and SUV options for office travel, business trips, and regular commuting."
  },
  {
    "name": "Pune to Mumbai Daily Taxi Fare",
    "description": "Check Pune to Mumbai Daily Taxi Fare with transparent packages, affordable rates, multiple vehicle choices, and no hidden charges."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Daily Cab Service",
    "description": "Book Pimpri Chinchwad to Mumbai Daily Cab Service with comfortable AC cars, professional chauffeurs, flexible schedules, and reliable daily transportation."
  },
  {
    "name": "Pune Mumbai Daily Cab Service",
    "description": "Choose Pune Mumbai Daily Cab Service for regular travel between Pune and Mumbai with fixed pricing, clean vehicles, experienced drivers, and 24x7 booking support."
  },
  {
    "name": "Mumbai to Pune Best Taxi Service",
    "description": "Select Mumbai to Pune Best Taxi Service with premium vehicles, professional chauffeurs, affordable fares, and comfortable intercity travel."
  },
  {
    "name": "Cheapest Cab Mumbai to Pune",
    "description": "Book Cheapest Cab Mumbai to Pune with budget-friendly fares, clean AC vehicles, reliable drivers, and convenient one way and round trip options."
  },
  {
    "name": "Best Cab Service Mumbai to Pune",
    "description": "Choose Best Cab Service Mumbai to Pune for safe travel with experienced chauffeurs, premium vehicles, fixed fares, and excellent customer support."
  },
  {
    "name": "Pune to Mumbai Daily Cab Service",
    "description": "Book Pune to Mumbai Daily Cab Service for regular office travel, business trips, airport transfers, and comfortable daily commuting with professional drivers."
  },
  {
    "name": "Pune to Mumbai Daily Cabs",
    "description": "Reserve Pune to Mumbai Daily Cabs with multiple vehicle options, affordable pricing, flexible schedules, and reliable chauffeur-driven transportation."
  },
  {
    "name": "Pune to Mumbai Daily Taxi Service",
    "description": "Travel with Pune to Mumbai Daily Taxi Service featuring clean AC vehicles, experienced drivers, fixed fares, and smooth highway journeys."
  },
  {
    "name": "Pune to Mumbai Daily Cab Booking",
    "description": "Complete Pune to Mumbai Daily Cab Booking online with instant confirmation, secure reservations, flexible pickup timings, and professional service."
  },
  {
    "name": "Pune to Mumbai Shared Cab Daily",
    "description": "Choose Pune to Mumbai Shared Cab Daily for affordable commuting with comfortable seating, reliable schedules, and convenient travel options."
  },
  {
    "name": "Pune to Mumbai One Way Cab",
    "description": "Book Pune to Mumbai One Way Cab with fixed fares, doorstep pickup, clean vehicles, and experienced chauffeurs for direct travel."
  },
  {
    "name": "Pune to Mumbai Taxi Service",
    "description": "Reserve Pune to Mumbai Taxi Service with Sedan, Ertiga, Innova Crysta, and SUV vehicles for safe and comfortable intercity transportation."
  },
  {
    "name": "Pune to Mumbai Cab Booking Online",
    "description": "Book Pune to Mumbai Cab Booking Online with quick confirmation, transparent pricing, multiple vehicle options, and 24x7 customer assistance."
  },
  {
    "name": "Pune to Mumbai Daily Travel Cab",
    "description": "Choose Pune to Mumbai Daily Travel Cab for regular commuting, office trips, corporate travel, and comfortable long-distance journeys."
  },
  {
    "name": "Pune to Mumbai Regular Cab Service",
    "description": "Hire Pune to Mumbai Regular Cab Service for frequent travel with fixed packages, professional drivers, and dependable transportation."
  },
  {
    "name": "Pune to Mumbai Cab Service Daily",
    "description": "Book Pune to Mumbai Cab Service Daily with affordable rates, premium AC vehicles, flexible timings, and experienced chauffeurs."
  },
  {
    "name": "Cheap Pune to Mumbai Daily Cab",
    "description": "Reserve Cheap Pune to Mumbai Daily Cab with economical fares, clean cars, professional drivers, and reliable daily travel solutions."
  },
  {
    "name": "Pune to Mumbai Outstation Cab",
    "description": "Choose Pune to Mumbai Outstation Cab for safe long-distance travel with fixed pricing, comfortable vehicles, and experienced chauffeurs."
  },
  {
    "name": "Pune to Mumbai AC Taxi Service",
    "description": "Travel comfortably with Pune to Mumbai AC Taxi Service featuring air-conditioned vehicles, affordable fares, and smooth highway transportation."
  },
  {
    "name": "Pune to Mumbai Cab Fare",
    "description": "Check Pune to Mumbai Cab Fare with transparent pricing, multiple vehicle categories, affordable packages, and no hidden charges."
  }
],

"tableData": [
  ["Pune Mumbai Daily Cab Rates", "Pune Mumbai Airport Drop Daily Cab"],
  ["Pune Mumbai Airport Daily One Way Cab", "Pune to Dadar Daily Cab Service"],
  ["Pune to Mumbai Cheapest Cab Service", "Pune to Mumbai Cab Travel Time"],
  ["Pune to Mumbai Daily Cab Contact Number", "Pune to Mumbai Airport Daily Cab Number"],
  ["Pune to Mumbai Daily Car Hire", "Pune to Mumbai Daily Taxi Fare"],
  ["Pimpri Chinchwad to Mumbai Daily Cab Service", "Pune Mumbai Daily Cab Service"],
  ["Mumbai to Pune Best Taxi Service", "Cheapest Cab Mumbai to Pune"],
  ["Best Cab Service Mumbai to Pune", "Pune to Mumbai Daily Cab Service"],
  ["Pune to Mumbai Daily Cabs", "Pune to Mumbai Daily Taxi Service"],
  ["Pune to Mumbai Daily Cab Booking", "Pune to Mumbai Shared Cab Daily"],
  ["Pune to Mumbai One Way Cab", "Pune to Mumbai Taxi Service"],
  ["Pune to Mumbai Cab Booking Online", "Pune to Mumbai Daily Travel Cab"],
  ["Pune to Mumbai Regular Cab Service", "Pune to Mumbai Cab Service Daily"],
  ["Cheap Pune to Mumbai Daily Cab", "Pune to Mumbai Outstation Cab"],
  ["Pune to Mumbai AC Taxi Service", "Pune to Mumbai Cab Fare"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune Mumbai Daily Cab Service",
    WhyChoosedescription: "Trustline Travels offers regular Pune to Mumbai daily cab services with professional drivers, comfortable vehicles, and dependable travel solutions for daily commuters."
  },
  {
    WhyChooseheading: "Convenient Daily Pickup & Drop",
    WhyChoosedescription: "Get scheduled pickup and drop services from Pune locations including Hinjewadi, Wakad, Baner, Kharadi, Viman Nagar, Pimpri Chinchwad, and nearby areas to Mumbai."
  },
  {
    WhyChooseheading: "Perfect for Office & Corporate Travel",
    WhyChoosedescription: "Our daily cab service is designed for employees, business professionals, corporate teams, and regular travelers commuting between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Comfortable Cars for Everyday Travel",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, and premium vehicles based on your comfort needs and passenger requirements."
  },
  {
    WhyChooseheading: "Experienced Regular Route Drivers",
    WhyChoosedescription: "Our drivers have excellent knowledge of the Pune Mumbai route, ensuring timely travel through efficient routes and traffic management."
  },
  {
    WhyChooseheading: "Flexible Monthly & Daily Plans",
    WhyChoosedescription: "Select daily, weekly, or monthly cab plans according to your commuting schedule and business travel requirements."
  },
  {
    WhyChooseheading: "Transparent Pricing & Easy Booking",
    WhyChoosedescription: "Enjoy clear fare details with affordable rates and simple booking options without hidden charges."
  },
  {
    WhyChooseheading: "24/7 Customer Support",
    WhyChoosedescription: "Our support team is available anytime to manage your daily cab requirements and provide quick assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune Mumbai Daily Cab Service?",
    answer: "Yes, Trustline Cab offers reliable daily cab services between Pune and Mumbai for office employees, corporate travelers, and regular commuters."
  },
  {
    question: "Who can use Pune Mumbai daily cab service?",
    answer: "The service is ideal for corporate employees, business professionals, IT employees, frequent travelers, and daily commuters."
  },
  {
    question: "Do you provide fixed pickup and drop locations?",
    answer: "Yes, we provide scheduled pickup and drop facilities from preferred locations in Pune and Mumbai."
  },
  {
    question: "Which vehicles are available for daily Pune Mumbai travel?",
    answer: "We provide Sedan cars, Ertiga, Innova, Innova Crysta, and other comfortable vehicles based on travel needs."
  },
  {
    question: "Can I book a monthly Pune Mumbai cab package?",
    answer: "Yes, monthly and customized travel plans are available for regular Pune Mumbai commuters."
  },
  {
    question: "Is Pune Mumbai daily cab service available every day?",
    answer: "Yes, daily cab services can be arranged according to your regular travel schedule and requirements."
  },
  {
    question: "Do you provide corporate employee transportation between Pune and Mumbai?",
    answer: "Yes, our services are suitable for corporate transportation, employee pickup-drop, and business travel."
  },
  {
    question: "Are toll and parking charges included in the daily cab fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally discussed separately based on the selected travel plan."
  },
  {
    question: "Can I reserve a dedicated cab for daily travel?",
    answer: "Yes, dedicated cab facilities are available for regular commuters who require consistent travel arrangements."
  },
  {
    question: "How can I book Pune Mumbai Daily Cab Service with Trustline Travels?",
    answer: "Share your pickup location, destination, travel timing, passenger details, and preferred vehicle to receive a customized quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Joshi",
    feedback: "Trustline Cab provides excellent Pune Mumbai daily cab service. The driver is punctual, the vehicle is comfortable, and the regular commute has become smooth and stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "The daily cab arrangement helped us save travel time and provided a comfortable office commute. The service quality, communication, and driver support are excellent.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Mumbai Daily Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-mumbai-daily-cab-service.webp",
  "description":
    "Book Pune Mumbai Daily Cab Service with Trustline Travels for safe, comfortable, and affordable daily taxi services. We provide one-way and round-trip daily cabs from Pune to Mumbai, Mumbai Airport, Dadar, Pimpri Chinchwad, and all Mumbai locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-mumbai-daily-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune Mumbai Daily Cab Service | Daily Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune Mumbai Daily Cab Service with Trustline Travels for reliable one-way and round-trip daily taxi services. Get affordable cabs from Pune to Mumbai, Mumbai Airport, Dadar, Pimpri Chinchwad, and all Mumbai locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7."
  />

  <meta
    name="keywords"
    content="Pune mumbai daily cab rates, pune mumbai airport drop daily cab, pune mumbai airport daily one way cab, pune to dadar daily cab service, pune to mumbai cheapest cab service, pune to mumbai cab travel time, pune to mumbai daily cab contact number, pune to mumbai airport daily cab number, pune to mumbai daily car hire, pune to mumbai daily taxi fare, pimpri chinchwad to mumbai daily cab service, pune mumbai daily cab service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punemumbaidailycabservice;